// extracted by mini-css-extract-plugin
export default {"mainBoxedContainer":"boxed-container-view__mainBoxedContainer___g8f4+","header":"boxed-container-view__header___5BSU8"};